module.exports = __webpack_public_path__ + "static/media/phoenix.e52c342d.svg";